export default {
    
    indexOccurrences:   { method: 'get',    url: 'occurrences' },
    createOccurrence:   { method: 'post',   url: 'occurrences'},
    updateOccurrence:   { method: 'put',    url: 'occurrences/{id}'},
    deleteOccurrence:   { method: 'delete', url: 'occurrences/{id}'},
    validateOccurrence: { method: 'put',    url: 'occurrences/{id}/validate'},
}